import axios from 'axios';

export default {
    list() {
        return axios.get(window.applicationSettings.apiEndpoint + '/risk/sectorindex/list')
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    },
    fetch(sectorindexId) {
        return axios.get(window.applicationSettings.apiEndpoint + '/risk/sectorindex/fetch/' + sectorindexId)
            .then(response => response.data)
            .catch(error => error.response);
    },
    create(payload) {
        var formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        return axios.post(window.applicationSettings.apiEndpoint + '/risk/sectorindex/create', formData)
            .then(response => response.data)
            .catch(error => error.response);
    },
    update(sectorindexId, payload) {
        var formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        return axios.post(window.applicationSettings.apiEndpoint + '/risk/sectorindex/update/' + sectorindexId, formData)
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    },
    delete(sectorindexId) {
        return axios.delete(window.applicationSettings.apiEndpoint + '/risk/sectorindex/delete/' + sectorindexId)
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    }
}